module.exports = __webpack_public_path__ + "img/California Outline.218ab026.png";